export const API = {
  mexalCustomers: {
    path: '/mexal-customers',
    method: 'GET',
    get: 'data',
    auth: true,
    fallback: [],
  },
  mexalSuppliers: {
    path: '/mexal-suppliers',
    method: 'GET',
    get: 'data',
    auth: true,
    fallback: [],
  },
  mexalCustomerByMexalID: {
    path: '/mexal-customers/{{id}}',
    method: 'GET',
    get: 'data',
    auth: true,
    fallback: [],
  },
  sendDeliveryNote: {
    path: '/mexal-gateway/send-delivery-note',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
  },
  sendOf: {
    path: '/mexal-gateway/send-of',
    method: 'POST',
    get: null,
    auth: true,
    fallback: null,
  },
};
